import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  fetchDoctorDetails, fetchAllDoctors, storeRequestCallback, fetchFilterOPD,
  fetchPatientStoryVideos, fetchAllSpecialities, fetchDoctorsVideos, fetchDoctorBlogs
} from "../Adapter/PageAdapter";
// import useSeo from "../hooks/useSeo";
import useSeoWithParam from "../hooks/useSeoWithParam";
import SeoHelmet from "../components/SeoHelmet";
import SeoDoctorHelmet from "../components/SeoDoctorHelmet";
import { TextField } from "@mui/material";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { Toaster, toast } from 'sonner';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { baseImage_path } from "../variables/Variables";
import SpecdetailBan from "../assets/images/Doctors-new.jpg";
import GraduationImg from "../assets/images/doc-detail/graduation-cap 1.svg";
import GlitterImg from "../assets/images/doc-detail/glitter 1.svg";
import BlogImg from "../assets/images/speci-detail/blog.jpg";
import userIcn from "../assets/images/doctor-profile.png";
import newArrImg from "../assets/images/arrw.svg";
import leftArrow from "../assets/images/doc-detail/leftwrrw.svg";
import blkArrow from "../assets/images/spciallites/blkarw.svg";

const YOUTUBE_API_KEY = "AIzaSyBw0nWsT0Weif6GRvDwBNVNzthNwh0XHQ8";

const formatExpertiseHTML = (htmlString) => {
  if (!htmlString) return '';

  // Replace <p>...</p> with <li>...</li>
  let updated = htmlString.replace(/<p>(.*?)<\/p>/g, '<li>$1</li>');

  // Wrap result in <ul> only if it contains <li>
  if (updated.includes('<li>')) {
    updated = `<ul class="list-disc pl-5">${updated}</ul>`;
  }

  return updated;
};


const DoctorDetails = () => {
  const { name, slug } = useParams();
  const [doctorDetails, setDoctorDetails] = useState(null);
  const [patientStories, setPatientStories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [formloading, setFormLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isManuallyOpened, setIsManuallyOpened] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [specialties, setSpecialties] = useState([]);
  const [doctorsList, setDoctorsList] = useState([]);
  const [doctorId, setDoctorId] = useState(null);
  const [videos, setVideos] = useState([]);
  const [playlistVideos, setPlaylistVideos] = useState([]);
  const [loadingVideos, setLoadingVideos] = useState(true);
  const [showSwiperControls, setShowSwiperControls] = useState(false);
  const [blogs, setBlogs] = useState([]);
  const [loadingBlogs, setLoadingBlogs] = useState(true);
  const [formData, setFormData] = useState({
    patientName: "",
    // countryCode: "",
    contactNo: "",
    email: "",
    speciality: "",
    doctor: "",
    date: "",
    message: "",
  });

  // const seoData = useSeo(fetchDoctorDetails);
  const seoData = useSeoWithParam(fetchDoctorDetails, slug);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const doctorResponse = await fetchDoctorDetails(slug);
        if (doctorResponse && doctorResponse.data) {
          setDoctorDetails(doctorResponse.data);
          setDoctorId(doctorResponse.data.id);
          // setSelectedSpeciality(doctorResponse.data.speciality_name || "");
          // setSelectedDoctor(doctorResponse.data.name || "");
          setFormData((prev) => ({
            ...prev,
            speciality_name: doctorResponse.data.speciality_names?.[0] || "",
	    speciality_id: doctorResponse.data.speciality_ids?.[0] || null,
            doctor_name: doctorResponse.data.name || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching doctor details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [slug]);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const storiesResponse = await fetchPatientStoryVideos();
        if (storiesResponse && storiesResponse.data) {
          setPatientStories(storiesResponse.data);
        }
      } catch (error) {
        console.error("Error fetching doctor details or patient stories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();

  }, []);

  useEffect(() => {
    const fetchSpecialties = async () => {
      try {
        const response = await fetchAllSpecialities();
        if (response && response.specialities) {
          setSpecialties(response.specialities);
        }
      } catch (error) {
        console.error("Error fetching specialties:", error);
      }
    };
    fetchSpecialties();
  }, []);

  // Fetch doctors when a specialty is selected
  const handleSpecialtyList = async (e) => {
    const specialityId = e.target.value;
    setFormData({
      ...formData,
      speciality: specialityId,
      doctor: "",
    });

    try {
      const response = await fetchFilterOPD(specialityId);
      if (response && response.data) {
        setDoctorsList(response.data);
      } else {
        setDoctorsList([]);
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  useEffect(() => {
    if (!isManuallyOpened) {  // Only trigger the timer if not manually opened
      const timer = setTimeout(() => {
        setShowModal(true);
      }, 15000);

      return () => clearTimeout(timer); // Cleanup timer on component unmount
    }
  }, [isManuallyOpened]);

  const fetchPlaylistVideos = async (playlistId) => {
    console.log("Fetching videos for playlistId:", playlistId);

    try {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=${playlistId}&key=${YOUTUBE_API_KEY}`
      );

      const data = await response.json();
      console.log("Fetched Playlist Data:", data);

      if (data.items && data.items.length > 0) {
        return data.items.map((item) => ({
          title: item.snippet.title,
          videoId: item.snippet.resourceId.videoId,
          thumbnailUrl: `https://img.youtube.com/vi/${item.snippet.resourceId.videoId}/hqdefault.jpg`,
          videoUrl: `https://www.youtube.com/watch?v=${item.snippet.resourceId.videoId}`
        }));
      }

      return [];
    } catch (error) {
      console.error("Error fetching playlist videos:", error);
      return [];
    }
  };

  // Handle Video Thumbnails Doctors
  const handleVideoThumbnails = async (videosList) => {
    let updatedVideos = [];
    let updatedPlaylistVideos = [];

    for (const video of videosList) {
      if (video.thumbnail_img) {
        updatedVideos.push({
          ...video,
          thumbnailUrl: `${baseImage_path}${video.thumbnail_img}`,
          videoUrl: video.video_url
        });
      }
      else if (video.video_url.includes("playlist")) {
        // console.log("Fetching Playlist Videos for URL:", video.video_url);
        const playlistId = video.video_url.match(/[?&]list=([a-zA-Z0-9_-]+)/)?.[1];

        if (playlistId) {
          const playlistVideos = await fetchPlaylistVideos(playlistId);

          // if (playlistVideos && playlistVideos.length > 0) {
          //   updatedPlaylistVideos = [...updatedPlaylistVideos, ...playlistVideos];
          // }
          if (playlistVideos && playlistVideos.length > 0) {
            const playlistVideosWithId = playlistVideos.map(v => ({
              ...v,
              playlistId
            }));

            updatedPlaylistVideos = [...updatedPlaylistVideos, ...playlistVideosWithId];
          }
        }
      }
      else {
        const videoId = video.video_url.match(/[?&]v=([^&]+)/)?.[1];
        const youtubeThumbnail = videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;

        updatedVideos.push({
          ...video,
          thumbnailUrl: youtubeThumbnail || "default-thumbnail.jpg",
          videoUrl: video.video_url
        });
      }
    }

    // console.log("Final Individual Videos List:", updatedVideos);
    // console.log("Final Playlist Videos List:", updatedPlaylistVideos);

    setVideos(updatedVideos);
    setPlaylistVideos(updatedPlaylistVideos);
  };

  // useEffect(() => {
  //   const fetchVideos = async () => {
  //     try {
  //       const videosResponse = await fetchDoctorsVideos(doctorId);  // Correct API call
  //       if (videosResponse && videosResponse.data) {
  //         // console.log("API Response Data:", videosResponse.data);
  //         await handleVideoThumbnails(videosResponse.data);
  //       }
  //     } catch (error) {
  //       // console.error("Error fetching doctor videos:", error);
  //     } finally {
  //       setLoadingVideos(false);
  //     }
  //   };

  //   fetchVideos();
  // }, [doctorId]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await fetchDoctorDetails(slug);
        console.log("You got URL!", res.data.video_link);
        if (res?.data) {
          const doctor = res.data;
          setDoctorDetails(doctor);

          if (doctor.video_link) {
            await handleVideoThumbnails([{ video_url: doctor.video_link }]);

          }
        }
      } catch (error) {
        console.error("Error fetching doctor details:", error);
      } finally {
        setLoadingVideos(false);
      }
    };

    fetchVideos();
  }, [slug]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await fetchDoctorBlogs(doctorId); // Use the doctor ID from the URL param
        if (response && response.data) {
          setBlogs(response.data);
        }
      } catch (error) {
        console.error("Error fetching doctor blogs:", error);
      } finally {
        setLoadingBlogs(false);
      }
    };

    fetchBlogs();
  }, [doctorId]);

  const handleOpenVideo = (url) => {
    setVideoUrl(url);
    setShowVideoModal(true);
  };
  const handleCloseVideo = () => {
    setShowVideoModal(false);
    setVideoUrl(null);

    // Manually remove Bootstrap modal-related classes
    document.body.classList.remove("modal-open");
    // Remove the modal backdrop if it exists
    const modalBackdrops = document.getElementsByClassName("modal-backdrop");
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Only allow numbers and plus in contactNo
    if (name === "contactNo" || name === "countryCode") {
      const sanitizedValue = value.replace(/(?!^)\+/g, "").replace(/[^0-9+]/g, "");
      setFormData({ ...formData, [name]: sanitizedValue });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleRequestCallback = () => {
    setShowModal(true);
    setIsManuallyOpened(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);

    // Manually remove Bootstrap modal-related classes
    document.body.classList.remove("modal-open");

    // Remove the modal backdrop if it exists
    const modalBackdrops = document.getElementsByClassName("modal-backdrop");
    while (modalBackdrops.length > 0) {
      modalBackdrops[0].parentNode.removeChild(modalBackdrops[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formloading) return;

    setFormLoading(true);

    // Proper field checks
    if (!formData.patientName || !formData.contactNo) {
      toast.error("Please fill all required fields.");
      return;
    }

    try {
      const payload = {
        patient_name: formData.patientName,
        // country_code: formData.countryCode,
        contact_number: formData.contactNo,
        email: formData.email,
      //  speciality_id: doctorDetails?.speciality_id,
	speciality_id: doctorDetails?.speciality_ids?.[0] || null,
        doctor_id: doctorDetails?.id,
        appointment_date: formData.date,
        message: formData.message,
        doctor_name: doctorDetails?.name,
       // speciality_name: doctorDetails?.speciality_name
	 speciality_name: doctorDetails?.speciality_names?.[0] || ""
      };

      // Call storeRequestCallback which handles both backend and CRM
      const { backendResult, crmResult } = await storeRequestCallback(payload);

      // if (backendResult?.message && crmResult?.status === "true") {
      if (
        (backendResult?.status === "true" || backendResult?.status === true) &&
        crmResult?.message
      ) {
        toast.success("Request submitted successfully, We will get back to you!");
        setFormData({
          patientName: "",
          // countryCode: "",
          contactNo: "",
          email: "",
          speciality: "",
          doctor: "",
          date: "",
          message: "",
        });
        handleCloseModal();
      } else {
        toast.error("Submission failed. Try again.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong.");
    }
    finally {
      setFormLoading(false);
    }
  };

  // const blogs = [
  //   {
  //     image: BlogImg,
  //     category: "Uncategorised",
  //     date: "July 10, 2024",
  //     title:
  //       "Patient Stories: Empowering for This Transformations at S.L. Raheja",
  //     link: "#",
  //   },
  //   {
  //     image: BlogImg,
  //     category: "Uncategorised",
  //     date: "July 10, 2024",
  //     title:
  //       "Patient Stories: Empowering for This Transformations at S.L. Raheja",
  //     link: "#",
  //   },
  //   {
  //     image: BlogImg,
  //     category: "Uncategorised",
  //     date: "July 10, 2024",
  //     title:
  //       "Patient Stories: Empowering for This Transformations at S.L. Raheja",
  //     link: "#",
  //   },
  // ];

  if (loading) {
    return <p>Loading doctor details...</p>;
  }

  if (!doctorDetails) {
    return <p>No doctor details available.</p>;
  }

  const {
    description,
    speciality_name,
    link,
    opd_schedules,
    education,
    special_interest_1,
    special_interest_2,
    special_interest_3,
  } = doctorDetails;


  return (
    <>
      {doctorDetails && <SeoDoctorHelmet doctor={doctorDetails} />}

      {/* Banner Section */}
      <section className="banner-spac">
        <div className="cust-container">
          <div className="banner-box">
            {/* <img src={SpecdetailBan} alt="" /> */}
            <img
              src={
                doctorDetails?.banner_img
                  ? `${baseImage_path}/${doctorDetails.banner_img.replace(/^\.\/?/, "")}`
                  : SpecdetailBan
              }
              alt={doctorDetails?.name || "Doctor Banner"}
            />
            <div className="ban-con">
              <h1>Our Doctors</h1>
            </div>
          </div>
        </div>
      </section>

      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover /> */}
      <Toaster position="top-right" />

      {/* Doc info */}
      <section className="our-doc-profile-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="row">
            <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
              <div className="our-doc-profile-left">
                <div className="our-doc-profi-img">
                  <img src={doctorDetails.img_path ? `${baseImage_path}/${doctorDetails.img_path}` : GlitterImg}
                    alt={doctorDetails.name} />
                </div>
                <div className="doc-profi-desc">
                  <h5>{doctorDetails.name_prefix} {doctorDetails.name}</h5>
                  <p>{doctorDetails.speciality_name}</p>
                  <p dangerouslySetInnerHTML={{ __html: doctorDetails.designation }} />
                  <p dangerouslySetInnerHTML={{ __html: doctorDetails.department }} />
                  {/* <span>Experience: {doctorDetails.experience} + Years</span><br /> */}
                  <span>
                    Experience: {doctorDetails.experience ? doctorDetails.experience.replace(/\+/g, '') + '+' : 'N/A'} Years
                  </span>
                </div>
              </div>
            </div>
            <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12">
              <div className="our-doc-profile-right">
                {doctorDetails.opd_schedules && doctorDetails.opd_schedules.length > 0 ? (
                  doctorDetails.opd_schedules.map((schedule, index) => (
                    <div key={index} className="doc-profi-right-itm">
                      <h5>OPD Days</h5>
                      {/* <h5>{schedule.days}</h5><br /> */}
                      <h5 dangerouslySetInnerHTML={{ __html: schedule.days }} /><br />
                      <h5 style={{ marginTop: "2rem" }}>OPD Timing</h5>
                      {/* <p>{`${schedule.start_time} - ${schedule.end_time}`}</p> */}
                      {/* <p> {(schedule.start_time === "00:00 AM" && schedule.end_time === "00:00 PM") ?
                        "By Appointment" :
                        `${schedule.start_time} - ${schedule.end_time}`
                      }</p> */}
                      <p dangerouslySetInnerHTML={{ __html: schedule.timing }} />
                    </div>
                  ))
                ) : (
                  <div className="doc-profi-right-itm">
                    <p>No OPD Schedule Available</p>
                  </div>
                )}
                <div className="doc-profi-right-itm">
                  <div className="jdapplybtn">
                    <a
                      href="#"
                      className="btn with-color with-arr"
                      data-toggle="modal"
                      data-target="#patienform"
                      onClick={handleRequestCallback}
                    >
                      Request a Call Back
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Info */}
      <section className="our-doc-introduc-sec mrgntop70 margnbot90">
        <div className="cust-container">
          <div className="doc-intro-head">
            <h5>Introduction:</h5>
            {/* <p>
              {doctorDetails.description}
            </p> */}
            <div className="ck-content" dangerouslySetInnerHTML={{ __html: doctorDetails.description }} />

          </div>
          {doctorDetails.education && (
            <div className="doc-intro-head">
              <h4>
                <img src={GraduationImg} alt="" />
                Educational Qualifications
              </h4>
              {/* <ul> */}
                {/* <li>{doctorDetails.education}</li> */}
                {/* <li> */}
                  <div className="ck-content" dangerouslySetInnerHTML={{ __html: doctorDetails.education }} />
                {/* </li> */}
              {/* </ul> */}
            </div>
          )}
          {/* {(doctorDetails.special_interest) && (
            <div className="doc-intro-head">
              <h4>
                <img src={GlitterImg} alt="" />
                Areas of Expertise:
              </h4>
              <ul>
                {doctorDetails.special_interest &&
                  doctorDetails.special_interest
                    .match(/<li>(.*?)<\/li>/g)
                    ?.map((item, index) => (
                      <li key={index} dangerouslySetInnerHTML={{ __html: item.replace(/<\/?li>/g, '') }} />
                    ))
                }
              </ul>
            </div>
          )} */}
          {doctorDetails.special_interest && doctorDetails.special_interest.replace(/<[^>]*>?/gm, "").trim() !== "" && (
            <div className="doc-intro-head">
              <h4>
                <img src={GlitterImg} alt="" />
                Areas of Expertise:
              </h4>
              <div className="ck-content" dangerouslySetInnerHTML={{ __html: doctorDetails.special_interest }} />
            </div>
          )}
        </div>
      </section>

      {/* Expert Insights */}
      {/* <section className="patient-story-sec mrgntop70 margnbot90" id="patientstoriesid">
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>Expert Insights</h4>
          </div>

          <div className="DocVideo-stories">
            <Swiper
              className="patvdo-slider"
              modules={[Autoplay, Navigation, Pagination]}
              loop={true}
              spaceBetween={5}
              slidesPerView={6}
              grabCursor={false}
              freeMode={false}
              mousewheel={false}
              keyboard={{ enabled: true }}
              // autoplay={{ delay: 30000 }}
              // pagination={{ clickable: true, el: ".swiper-pagination1" }}
              autoplay={showSwiperControls ? { delay: 30000 } : false}
              pagination={showSwiperControls ? { clickable: true, el: ".swiper-pagination1" } : false}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 1 },
                1024: { slidesPerView: 6 },
              }}
              // navigation={{
              //   nextEl: ".swiper-cust1-next",
              //   prevEl: ".swiper-cust1-prev",
              // }}
              navigation={showSwiperControls ? {
                nextEl: ".swiper-cust1-next",
                prevEl: ".swiper-cust1-prev",
              } : false}
            >
              {patientStories.map((story, index) => {
                // Extract YouTube Video ID
                const videoIdMatch = story.video_link.match(/(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
                const videoId = videoIdMatch ? videoIdMatch[1] : null;

                // Determine thumbnail URL
                const thumbnailUrl = story.blog_img
                  ? `${baseImage_path}/${story.blog_img.replace(/^\.\/?/, "")}`
                  : videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : grid1Img; // Use grid1Img as fallback

                // Render two videos in a column if index is a multiple of 3
                if (index % 3 === 2 && index + 1 < patientStories.length) {
                  return (
                    <SwiperSlide key={story.id} className="patient-col2">
                      <div className="patient-col-inner">
                        {patientStories.slice(index, index + 2).map((v) => {
                          const videoIdInner = v.video_link.match(/(?:youtube\.com\/.*v=|youtu\.be\/)([^&]+)/)?.[1];
                          const thumbnailUrlInner = v.blog_img
                            ? `${baseImage_path}${v.blog_img.replace(/^\.\/?/, "")}`
                            : videoIdInner ? `https://img.youtube.com/vi/${videoIdInner}/hqdefault.jpg` : grid2Img;

                          return (
                            <div key={v.id} className="patien-img">
                              <img src={thumbnailUrlInner} alt={v.name || "Patient Video"} />
                              <div className="patien-vdoplaybtn">
                                {videoIdInner && (
                                  <button onClick={() => handleOpenVideo(`https://www.youtube.com/embed/${videoIdInner}`)}>
                                    <img src={videoPlaybtn} alt="Play Button" />
                                  </button>
                                )}
                              </div>
                              <div className="patien-desc">
                                <h4>{v.heading || "Patient Story"}</h4>
                                <span>{v.name || "Unknown"}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </SwiperSlide>
                  );
                }

                // Render single videos
                return (
                  <SwiperSlide key={story.id} className={index % 3 === 0 ? "patient-col1" : "patient-col3"}>
                    <div className="fullPateint-item">
                      <div className="patien-img">
                        <img src={thumbnailUrl} alt={story.name || "Patient Story"} />
                        <div className="patien-vdoplaybtn">
                          {videoId && (
                            <button onClick={() => handleOpenVideo(`https://www.youtube.com/embed/${videoId}`)}>
                              <img src={videoPlaybtn} alt="Play Button" />
                            </button>
                          )}
                        </div>
                        <div className="patien-desc">
                          <h4>{story.heading || "Patient Story"}</h4>
                          <span>{story.name || "Unknown"}</span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>

            {showSwiperControls && (
              <div className="videostory-cta" style={{ cursor: "pointer" }}>
                <span className="swiper-cust1-prev"> &lt; </span>
                <div className="vdostory-naviga">
                  <span className="swiper-pagination1"></span>
                </div>
                <span className="swiper-cust1-next"> &gt; </span>
              </div>
            )}
          </div>
        </div>
      </section> */}

      {/* Expert Insights Videos Playlist */}
      {(videos.length > 0 || playlistVideos.length > 0) && (
        <section className="patient-story-sec mrgntop70 margnbot90" id="patientstoriesid">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Expert Insights</h4>
            </div>
            <div className="DocVideo-stories">
              <Swiper
                className="patvdo-slider"
                modules={[Autoplay, Navigation]}
                loop={true}
                spaceBetween={15}
                autoplay={{ delay: 8000 }}
                navigation={{
                  nextEl: ".video-swiper-next-spec",
                  prevEl: ".video-swiper-prev-spec",
                }}
                onInit={(swiper) => {
                  swiper.navigation.init();
                  swiper.navigation.update();
                }}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  1024: { slidesPerView: 2 },
                  1280: { slidesPerView: 3 },
                }}
              >
                {[...videos, ...playlistVideos].map((video, index) => (
                  <SwiperSlide key={index}>
                    <div className="our-video-sec-item DoctorsSpeciPage">
                      <div className="our-video-img">
                        <img
                          src={video.thumbnailUrl || "default-thumbnail.jpg"}
                          alt={video.title || "Video"}
                          style={{ width: "100%", height: "200px", objectFit: "cover" }}
                        />
                      </div>
                      <div className="our-video-desc">
                        <h4>{video.title || "Video Title"}</h4>
                        <a href={video.videoUrl} target="_blank" rel="noopener noreferrer">
                          Watch now <img src={blkArrow} alt="Arrow" />
                        </a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              {/* Navigation Arrows */}
              <div className="video-slider-nav-Spec">
                <span className="video-swiper-prev-spec">
                  <img src={leftArrow} alt="Previous" />
                </span>
                <span className="video-swiper-next-spec">
                  <img src={leftArrow} alt="Next" style={{ transform: "rotate(180deg)" }} />
                </span>
              </div>
            </div>
            <div style={{ textAlign: 'center' }}>
              {playlistVideos.length > 0 && playlistVideos[0].playlistId && (
                <a
                  className="btn btn-primary"
                  style={{ background: "rgb(69 69 69)", color: "#fff", marginTop: '20px' }}
                  href={`https://www.youtube.com/playlist?list=${playlistVideos[0].playlistId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View All
                </a>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Our Blogs */}
      {/* <section className="our-video-sec mrgntop70 margnbot90" id="ourblogid">
        <div className="cust-container">
          <div className="finnest host-det text-center margin-botom40">
            <h4>Our Blogs</h4>
          </div>
          <div className="row">
            {blogs.map((blog, index) => (
              <div
                key={index}
                className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mb-4"
              >
                <div className="our-video-sec-item">
                  <div className="our-video-img">
                    <img src={blog.image} alt={blog.title} />
                    <div className="our-vdo-categ">
                      <span>{blog.category}</span>
                    </div>
                  </div>
                  <div className="our-video-desc our-vdo-desc-cta-green">
                    <span>{blog.date}</span>
                    <p>{blog.title}</p>
                    <NavLink to="/blogs">Read More</NavLink>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      {blogs.length > 0 && (
        <section className="our-video-sec mrgntop70 margnbot90" id="ourblogid">
          <div className="cust-container">
            <div className="finnest host-det text-center margin-botom40">
              <h4>Our Blogs</h4>
            </div>
            <div className="our-video-slider">
              <Swiper
                modules={[Autoplay, Navigation]}
                loop={true}
                spaceBetween={15}
                // slidesPerView={3}
                autoplay={{ delay: 8000 }}
                navigation={{
                  nextEl: ".swiper-cust2-next",
                  prevEl: ".swiper-cust2-prev",
                }}
                breakpoints={{
                  640: { slidesPerView: 1 },
                  1024: { slidesPerView: 2 },
                  1280: { slidesPerView: 3 },
                }}
              >
                {blogs.map((blog, index) => (
                  <SwiperSlide key={index}>
                    <div className="our-video-sec-item">
                      <div className="our-video-img">
                        <img
                          src={blog.featured_img ? `${baseImage_path}/${blog.featured_img}` : BlogImg}
                          alt={blog.title}
                        />
                        <div className="our-vdo-categ">
                          <span>{blog.category || "Uncategorised"}</span>
                        </div>
                      </div>
                      <div className="our-video-desc our-vdo-desc-cta-green">
                        <span>{new Date(blog.created_at).toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        })}</span>
                        <p>{blog.title || "No Title"}</p>
                        <a href={`/blogs/${blog.slug}`}>Read More</a>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
              <div className="videostory-cta">
                <span className="swiper-cust2-prev"> &lt; </span>
                <span className="swiper-cust2-next"> &gt; </span>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Modal for patient form */}
      {showModal && (
        <div
          className="modal fade custmodal-width custom-modalwdth2 show"
          style={{ display: "block" }}
          id="patienform"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalclosebtn">
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="intern-form-inner">
                  <h5>Request A Call Back Form:</h5>
                  <form onSubmit={handleSubmit}>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="patientName">
                            Full Name of the Patient <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="patientName"
                            name="patientName"
                            value={formData.patientName}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="int-form-item">
                          <label htmlFor="contactNo">
                            Contact No <span>*</span>
                          </label>
                          <input
                            type="text"
                            id="contactNo"
                            name="contactNo"
                            value={formData.contactNo}
                            onChange={handleInputChange}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="email">Email</label>
                          <input
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <TextField
                            label="Speciality Name"
                            value={doctorDetails?.speciality_names?.[0] || ''}
                            InputProps={{ readOnly: true }}
                            fullWidth
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <TextField
                            label="Doctor Name"
                            value={doctorDetails?.name || ''}
                            InputProps={{ readOnly: true }}
                            fullWidth
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="date">Please Select Date <span>*</span></label>
                          <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleInputChange}
                            min={new Date().toISOString().split("T")[0]}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-12">
                        <div className="int-form-item">
                          <label htmlFor="message">Message</label>
                          <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleInputChange}
                            rows="5"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-12">
                        <div className="int-form-item">
                          <button type="submit" disabled={formloading}>
                            {formloading ? (
                              <>
                                <img src={newArrImg} alt="" className="spin" />
                                Sending...
                              </>
                            ) : (
                              <>
                                <img src={newArrImg} alt="" />
                                Submit
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal for patient video */}
      {showVideoModal && (
        <div
          className="modal fade custmodal-width show"
          style={{ display: "block" }}
          id="patientvdo"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modalclosebtn">
                <button
                  type="button"
                  className="close"
                  onClick={handleCloseVideo}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                {videoUrl && (
                  <iframe
                    src={videoUrl}
                    title="Video Player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DoctorDetails;
